import React, { useState } from "react";
import {
  AppComponents,
  RMFlightWrapper,
  FlightTypeSelect,
  Mapper,
} from "../../../../types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { trackFlightDetails } from "../../../analytics/AnalyticsActions";
import { changeSelectedFlight } from "../../searchFlightsSlice";
import SearchFlightsResultDetailsSFO from "./SearchFlightsResultDetailsSFO";
import SearchFlightsResultRowSFO from "./SearchFlightsResultRowSFO";

type SearchFlightsResultProps = {
  result: RMFlightWrapper;
  index: number;
  dateMin: Date;
  dateMax: Date;
  mapper: Mapper;
  components: AppComponents;
  layout: string;
};

function SearchFlightsResultSFO({
  result,
  index,
  mapper,
}: SearchFlightsResultProps) {
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const flightType = useAppSelector(
    (state) => state.searchFlights.form.flightType
  );
  const directionType = useAppSelector(
    (state) => state.searchFlights.results.type
  );
  const selectFlight = () => {
    dispatch(changeSelectedFlight(result));
    dispatch(trackFlightDetails(result));
    setCollapsed(!collapsed);
  };

  return (
    <div
      style={
        index % 2 === 0
          ? { backgroundColor: "#FFFFFF" }
          : { backgroundColor: "#f0f5f8" }
      }
      className="flight-result-item p-2"
      role="row"
    >
      <div
        onClick={selectFlight}
        title={t("TITLE_CLICK_FOR_DETAILS")}
        tabIndex={0}
        className="flight-result"
      >
        <div className="is-hidden-div sfo-category columns is-mobile is-vcentered ">
          <div className="column is-flex-direction-column pl-0">
            <div className="column px-0 airline-column" role="cell">
              {t("HEADER_SORT_AIRLINE")}
            </div>
            <div className="column px-0" role="cell">
              {t("LABEL_AIRCRAFT")}
            </div>
            <div className="column px-0" role="cell">
              {t("LABEL_ORIGIN")}
            </div>
            <div className="column px-0" role="cell">
              {t("FLIGHT")}
            </div>
            <div className="column px-0" role="cell">
              {t("LABEL_DESTINATION")}
            </div>
            <div className="column px-0" role="cell">
              {t("DEPARTS")}
            </div>
            <div className="column px-0" role="cell">
              {t("ARRIVES")}
            </div>
            <div className="column px-0 flight-stops" role="cell">
              {t("HEADER_SORT_STOPS")}
            </div>
            <div className="column px-0" role="cell">
              {t("LABEL_TOTAL_FLIGHT_TIME")}
            </div>
          </div>
          {(flightType === FlightTypeSelect.Connecting ||
            flightType === FlightTypeSelect.All) &&
            directionType === "connectionAirport" && (
              <div className="column is-flex-direction-column py-0 pl-0">
                <div className="column px-0 airline-column" role="cell">
                  {t("HEADER_SORT_AIRLINE")}
                </div>
                <div className="column px-0" role="cell">
                  {t("LABEL_AIRCRAFT")}
                </div>
                <div className="column px-0" role="cell">
                  {t("LABEL_ORIGIN")}
                </div>
                <div className="column px-0" role="cell">
                  {t("FLIGHT")}
                </div>
                <div className="column px-0" role="cell">
                  {t("LABEL_DESTINATION")}
                </div>
                <div className="column px-0" role="cell">
                  {t("DEPARTS")}
                </div>
                <div className="column px-0" role="cell">
                  {t("ARRIVES")}
                </div>
                <div className="column px-0 flight-stops" role="cell">
                  {t("HEADER_SORT_STOPS")}
                </div>
                <div className="column px-0">
                  {t("LABEL_TOTAL_FLIGHT_TIME")}
                </div>
              </div>
            )}
          <div className="column px-0" role="cell">
            {t("LABEL_DETAILS")}
          </div>
        </div>
        <div className="sfo-category columns is-mobile is-vcentered">
          <SearchFlightsResultRowSFO result={result} mapper={mapper} />
          <div className="column detail-item px-0" role="cell">
            <span>{collapsed ? t("SHOW_LABEL") : t("HIDE_LABEL")}</span>
            <div className="is-narrow">
              {collapsed && <FontAwesomeIcon icon={faChevronDown} />}
              {!collapsed && <FontAwesomeIcon icon={faChevronUp} />}
            </div>
          </div>
        </div>
      </div>
      {!collapsed && (
        <>
          <SearchFlightsResultDetailsSFO result={result} />
          {(result.codeshareInd ||
            result.connxLeg2CodeshareInd ||
            result.connxLeg3CodeshareInd) && (
            <p className="flight-detail-info">{t("SFO_FILGHT_INFO_DETAIL")}</p>
          )}
        </>
      )}
    </div>
  );
}

export default SearchFlightsResultSFO;
